import { autoinject } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { validate } from 'app/shared/elements/ess-rule';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssFormPage extends ComponentBase implements IForm {
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////

    protected validate = validate;

    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 1 ********************************************////

    protected ex1Text: string = '';
    protected ex1Comments: string[] = [];

    protected ex1Clear(): void {
        this.ex1Text = '';
    }

    protected ex1Submit(): void {
        this.ex1Comments.push(this.ex1Text);
        if(this.ex1Comments.length > 3) this.ex1Comments.shift();
        this.ex1Clear();
    }

    ////****************** Example 2 ********************************************////

    protected ex2Text?: string | null;
    protected ex2Comments: string[] = [];
    protected ex2Options: string[] = ['No', 'Yes'];
    protected ex2Select?: string | null;

    protected ex2Clear(): void {
        this.ex2Text = null;
        this.ex2Select = null;
    }

    protected ex2Submit(): void {
        if(!this.ex2Text) return;
        this.ex2Comments.push(this.ex2Text);
        if(this.ex2Comments.length > 3) this.ex2Comments.shift();
        this.ex2Clear();
    }

    ////****************** Example 3 ********************************************////

    protected $addComment!: any; // any to access the component's private properties
    protected ex3CareTeamParticipants: { name: string }[] = [{ name: 'Phillip' }, { name: 'Turanga' }, { name: 'Rodriguez' }];
    protected ex3Comments: string[] = [];

    // hacky manipulation of AddComment component for demo purposes; do not replicate
    protected ex3Submit(): void {
        let resultString = '';
        const participants = this.$addComment.selectedCareTeamParticipants;
        if(participants.length > 0) {
            resultString += '(Deliver to ';
            resultString += participants.map((p: { name: string }) => p.name).join(', ');
            resultString += '): ';
        }
        resultString += this.$addComment.commentText;
        this.ex3Comments.push(resultString);
        if(this.ex3Comments.length > 3) this.ex3Comments.shift();
        this.$addComment.reset();
    }

    ////****************** Example 4 ********************************************////

    protected ex4Text: string = '';
    protected ex4Comments: string[] = [];
    protected ex4ShowRequiredFieldsMessage: boolean = true;
    protected ex4Delay: number = 1000;

    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public submittedChanges?: any;
    public async submit(): Promise<boolean> {
        return new Promise(() => {
            this.state.beginSave();
            setTimeout(() => {
                this.ex4Comments.push(this.ex4Text);
                if(this.ex4Comments.length > 3) this.ex4Comments.shift();
                this.reset();
                this.state.endSave();
            }, this.ex4Delay);
        });
    }

    public reset(): void {
        this.ex4Text = '';
    }

}
